export default {
    namespaced: true,
    state: {
		endpoint: 'vehicle/request',
		item: {
			id: null,
			//users: [],
			//services: [],
		},
        items: [],
    },
	actions: {
		clearItem(context) {
			context.commit('item', {
				id: null,
				//users: [],
				//services: [],
			})
		},
	}
}